import React from "react";
import styles from "./style.module.scss";

const SubTabs = ({ currentMainTab, activeSubTab, setActiveSubTab }) => {
  return (
    <div className={styles.subTabs}>
      {currentMainTab && currentMainTab.subTabs.length > 0 ? (
        currentMainTab.subTabs.map((subTab) => (
          <button
            key={subTab.id}
            className={`${styles.subTab} ${
              activeSubTab === subTab.id ? styles.active : ""
            }`}
            onClick={() => setActiveSubTab(subTab.id)}
          >
            {subTab.label}
          </button>
        ))
      ) : (
        <div className={styles.subTabPlaceholder} />
      )}
    </div>
  );
};

export default SubTabs;
